<template>
    <div class="container px-0">
        <div class="row">
            <div class="col-12">
                <h4 class="text-dark">Create Toolbox Talks Topic</h4>
            </div>

            <div class="col-12">
                <div class="mt-4" style="max-width: 480px">

                    <!--Topic Name-->
                    <div class="form-group row">
                        <div class="col-12">
                            <label>Topic Name</label>
                            <input type="text" placeholder="Topic Name" v-model="name" class="form-control">
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12">
                            <label>Image</label>
                            <div style="">
                                <img v-if="image_url" class="img-fluid" :src="image_url" alt="">
                            </div>
                            <upload-image-button
                                v-model="image_url"
                                class="mt-3"
                                button_class="btn btn-primary"
                                :label="image_url ? 'Change' : 'Upload'"
                                @file="image_file = $event"
                            ></upload-image-button>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12">
                            <label>Description</label>
                            <textarea v-model="description" class="form-control" style="resize: none" rows="18"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import UploadImageButton from "../general_components/UploadImageButton";
	export default {
		name: "ToolboxTalkCreateEditPage",
		components: {UploadImageButton},
		props: [
        	'store_url',
            'back_url',
            'toolbox_talk'
        ],

        data(){
			return {
				name: '',
                image_url: '',
				image_file: null,
				description: null,
                errors: [],
                saving: false,
            }
        },

        beforeMount(){
			if (this.toolbox_talk){
				this.name = this.toolbox_talk.name;
				this.image_url = this.toolbox_talk.photo_url;
				this.description = this.toolbox_talk.description;
            }
            window.addEventListener('LAYOUT:primary_button', this.save);
            window.addEventListener('LAYOUT:cancel_button', this.cancel);
        },


        methods: {
			save(){
                this.errors = [];

				let _this = this;

				if (_this.saving){
					return false;
                }

				_this.saving = true;

				let formData = new FormData();
				formData.append('name', _this.name);
				if (_this.update) formData.append('_method', 'PUT');

				if (_this.description)formData.append('description', _this.description);
				if (_this.image_file)formData.append('image_file', _this.image_file);

                axios.post(_this.store_url, formData, {
                    headers: {
                        'Content-Type' : 'multipart/form-data',
                        'Accept' : 'application/json'
                    }
                })
                    .then(function (response){
                        _this.saving = false;
                        window.location.href = _this.back_url;
                    })
                    .catch(function (error){
                        _this.saving = false;

                        if (error.response.data.errors !== undefined) {
                            Object.values(error.response.data.errors).forEach((err, i) => {
                                _this.errors.push(`<li>${err[0]}</li>`);
                            });
                        }

                        if (_this.errors.length >= 2) {
                            Vue.$toast.open({
                                message: `There were ${_this.errors.length} errors: ${_this.errors.join('')}`,
                                type: 'error'
                            });
                        } else if (_this.errors.length === 1) {
                            Vue.$toast.open({
                                message: `There was an error: ${_this.errors.join('')}`,
                                type: 'error'
                            });
                        }
                    });
            },
            cancel(){
			    window.location.href = this.back_url;
            }
        }
	}
</script>
